export default __webpack_public_path__ + "static/timberline-24-ORBITAL-SCRUBBER-hospital-1f9c237e9fa62f3e254566093fd773b1.jpg";